<template>
  <div class="container">
    <section class="w1200">
      <nav>当前位置：首页 > 个人中心</nav>
      <div class="main flex">
        <div class="main_left">
          <div class="left_top" v-if="info">
            <h2>Hello! {{ info.userName }}</h2>
            <a @click="showBindPhone" v-if="!info.phone">绑定手机号</a>
            <a class="phone-num" v-else>{{ info.phone }}</a>
            <a @click="showBindEmail" v-if="!info.email">绑定邮箱</a>
            <a class="phone-num" v-else>{{ info.email }}</a>

            <div class="price flex">
              <img src="../../assets/images/price.png" alt="" />
              <div class="price-info">
                <p>
                  {{
                    info.resourceValue ? info.resourceValue.toFixed(2) : "0.00"
                  }}
                </p>
                <p>资源价值</p>
              </div>
            </div>
          </div>
          <ul class="item">
            <li @click="handleChangeTab(1)" :class="{ checked: tabIndex == 1 }">
              <img :src="tabIndex == 1 ? icon1_checked : icon1" />我的申请
            </li>
            <li @click="handleChangeTab(6)" :class="{ checked: tabIndex == 6 }">
              <img :src="tabIndex == 6 ? icon6_checked : icon6" />我的文献传递
            </li>
            <li @click="handleChangeTab(2)" :class="{ checked: tabIndex == 2 }">
              <img :src="tabIndex == 2 ? icon2_checked : icon2" />收藏文章
            </li>
            <li @click="handleChangeTab(3)" :class="{ checked: tabIndex == 3 }">
              <img :src="tabIndex == 3 ? icon3_checked : icon3" />收藏期刊<i
                v-show="qkicon"
                class="addicon"
              ></i>
            </li>
            <li @click="handleChangeTab(9)" :class="{ checked: tabIndex == 9 }">
              <img :src="tabIndex == 9 ? icon9_checked : icon9" />收藏资讯
            </li>
            <li
              class="big"
              @click="handleChangeTab(8)"
              :class="{ checked: tabIndex == 8 }"
            >
              <img :src="tabIndex == 8 ? icon8_checked : icon8" />关注的作者<i
                class="addicon"
                v-show="authoricon"
              ></i>
            </li>
            <li @click="handleChangeTab(4)" :class="{ checked: tabIndex == 4 }">
              <img :src="tabIndex == 4 ? icon4_checked : icon4" />更换手机号
            </li>
            <li @click="handleChangeTab(5)" :class="{ checked: tabIndex == 5 }">
              <img :src="tabIndex == 5 ? icon5_checked : icon5" />更换邮箱
            </li>
            <li
              class="small"
              @click="handleChangeTab(7)"
              :class="{ checked: tabIndex == 7 }"
            >
              <img :src="tabIndex == 7 ? icon7_checked : icon7" />我的文献
            </li>
            <!-- <li @click="handleLoginout">
              <img src="../../assets/images/exit.png" />退出账号
            </li> -->
          </ul>
        </div>
        <div class="main_right">
          <my-apply v-if="tabIndex == 1"></my-apply>
          <my-article v-if="tabIndex == 2"></my-article>
          <my-home v-if="tabIndex == 3"></my-home>
          <my-author v-if="tabIndex == 8"></my-author>
          <my-news v-if="tabIndex == 9"></my-news>
          <change-phone
            v-if="tabIndex == 4"
            @childByPhone="getMineInfo"
          ></change-phone>
          <change-email
            v-if="tabIndex == 5"
            @childByEmail="getMineInfo"
          ></change-email>
          <my-deliver v-if="tabIndex == 6"></my-deliver>
          <my-cloud v-if="tabIndex == 7"></my-cloud>
        </div>
      </div>
    </section>
    <el-dialog title="绑定手机号" :visible.sync="bindPhoneVisible" width="30%">
      <div class="dialogInfo">
        <div class="item flex">
          手机号:
          <div class="flex phone">
            <el-input placeholder="请输入手机号" v-model="phone" />
            <span class="code" v-if="show" @click="getCode">发送验证码</span>
            <span class="code" v-else>{{ times }}</span>
          </div>
        </div>
        <div class="item flex">
          验证码:
          <el-input placeholder="请输入验证码" v-model="code" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindPhoneVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBindPhone">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="绑定邮箱" :visible.sync="bindEmailVisible" width="30%">
      <div class="dialogInfo">
        <div class="item flex">
          邮箱:
          <div class="flex phone">
            <el-input placeholder="请输入邮箱" v-model="email" clearable />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindEmailVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBindEmail">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChangePhone from "./changePhone";
import ChangeEmail from "./changeEmail";
import MyApply from "./myApply";
import MyDeliver from "./myDeliver";
import MyArticle from "./myArticle";
import MyHome from "./myHome";
import MyCloud from "./myCloud";
import MyAuthor from "./myAuthor";
import MyNews from "./myNews";
export default {
  name: "Mine",
  data() {
    return {
      tabIndex: 1,
      icon1: require("../../assets/images/grzx-wdsq.png"),
      icon1_checked: require("../../assets/images/grzx-wdsq-x.png"),
      icon2: require("../../assets/images/grzx-scwz.png"),
      icon2_checked: require("../../assets/images/grzx-scwz-x.png"),
      icon3: require("../../assets/images/grzx-scqk.png"),
      icon3_checked: require("../../assets/images/grzx-scqk-x.png"),
      icon4: require("../../assets/images/grzx-ghsjh.png"),
      icon4_checked: require("../../assets/images/grzx-ghsjh-x.png"),
      icon5: require("../../assets/images/grzx-e.png"),
      icon5_checked: require("../../assets/images/grzx-e-x.png"),
      icon6: require("../../assets/images/grzx-wxcd.png"),
      icon6_checked: require("../../assets/images/grzx-wxcd-x.png"),
      icon7: require("../../assets/images/icon-wdwx-mr.png"),
      icon7_checked: require("../../assets/images/icon-wdwx-xz.png"),
      icon8: require("../../assets/images/icon-author.png"),
      icon8_checked: require("../../assets/images/icon-author-checked.png"),
      icon9: require("../../assets/images/icon-news.png"),
      icon9_checked: require("../../assets/images/icon-news-checked.png"),
      bindPhoneVisible: false,
      phone: "",
      code: "",
      info: null,
      show: true,
      times: 60,
      bindEmailVisible: false,
      email: "",
      authoricon: false,
      qkicon: false,
    };
  },
  components: {
    ChangeEmail,
    ChangePhone,
    MyApply,
    MyArticle,
    MyHome,
    MyDeliver,
    MyCloud,
    MyAuthor,
    MyNews,
  },
  mounted() {
    this.getMineInfo();
    this.stateinfo();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    showBindPhone() {
      this.phone = "";
      this.code = "";
      this.bindPhoneVisible = true;
    },
    showBindEmail() {
      this.email = "";
      this.bindEmailVisible = true;
    },
    stateinfo() {
      // 分别请求两种订阅状态
      const requests = [1, 3].map((type) =>
        this.$http.get(`api/v1/usershare/check/subscribe/data?type=${type}`)
      );
      Promise.all(requests).then((responses) => {
        // 假设返回结构：[type1响应, type2响应]
        this.qkicon = responses[0].data; // 作者订阅状态
        this.authoricon = responses[1].data; // 期刊订阅状态
      });
    },
    getMineInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then((res) => {
        this.info = res.data;
      });
    },
    handleChangeTab(index) {
      this.tabIndex = index;
    },
    toHome() {
      this.$router.push({ path: "/article" });
    },
    getCode() {
      if (!this.phone) {
        this.$message.error("请输入新手机号");
        return;
      }
      this.times = 60;
      let formData = new FormData();
      formData.append("mobilePhone", this.phone);

      this.$http({
        url: "api/v1/user/sendCode",
        method: "POST",
        data: formData,
      }).then((res) => {
        this.show = false;
        this.timer = setInterval(() => {
          this.times--;
          if (this.times === 0) {
            this.show = true;
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
    saveBindPhone() {
      if (!this.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: "api/v1/user/changephone",
        method: "POST",
        data: formData,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.bindPhoneVisible = false;
          this.phoneVal = "";
          this.codeVal = "";
          this.getMineInfo();
        }
      });
    },
    saveBindEmail() {
      if (!this.email) {
        this.$message.error("请输入邮箱");
        return;
      }
      if (!this.validateEmail(this.email)) {
        this.$message.error("邮箱格式不正确");
        return;
      }
      let postBody = {
        newMail: this.email,
      };
      this.$http({
        url: "api/v1/user/change/mail",
        method: "POST",
        data: postBody,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.bindEmailVisible = false;
          this.email = "";
          this.getMineInfo();
        }
      });
    },
    validateEmail(email) {
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailRegex.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 160px);
  .addicon {
    width: 7px;
    height: 7px;
    background: #ff0000;
    border-radius: 3.5px;
    position: relative;
    margin-top: -12px;
    margin-left: 3px;
  }
  .w1200 {
    min-height: calc(100vh - 219px);
    padding-bottom: 30px;
    nav {
      padding: 20px 0;
      font-size: 14px;
      color: #999999;
    }
    .main {
      height: 100%;
      .main_left {
        background: rgba(21, 186, 188, 0.1);
        width: 250px;
        .left_top {
          padding: 0 30px;
          h2 {
            padding-left: 20px;
            padding-top: 50px;
          }
          a {
            padding-left: 20px;
            color: #2d8cf0;
            font-size: 14px;
            margin-top: 15px;
            display: inline-block;
            width: 100%;
            border-bottom: 1px solid #fbf4f4;
            padding-bottom: 20px;
          }
          .phone-num {
            cursor: text;
          }
          .price {
            margin-top: 20px;
            border-bottom: 1px solid #fbf4f4;
            padding-bottom: 20px;
            .price-info {
              margin-left: 10px;
              p {
                &:nth-of-type(1) {
                  font-size: 24px;
                }
                &:nth-of-type(2) {
                  font-size: 12px;
                  color: #999999;
                }
              }
            }
          }
        }
        .item {
          padding-left: 10px;
          padding-top: 30px;
          li {
            display: flex;
            align-items: center;
            padding: 10px 0;
            padding-left: 50px;
            cursor: pointer;
            img {
              margin-right: 10px;
              width: 20px;
            }
          }
          .small {
            img {
              width: 18px;
            }
          }
          .checked {
            background: #fff;
            color: #2d8cf0;
          }
        }
      }
      .main_right {
        flex: 1;
        min-width: 0;
        background: #fff;
      }
    }
  }
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .dialogInfo {
    padding: 0 40px;
    .item {
      align-items: center;
      margin-bottom: 15px;
      font-size: 16px;
      &:last-of-type {
        margin: 0;
      }
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      .el-input {
        flex: 1;
        margin-left: 10px;
      }
      .phone {
        flex: 1;
        position: relative;
        .code {
          position: absolute;
          right: 0;
          height: 40px;
          line-height: 40px;
          color: #2d8cf0;
          padding: 0 20px;
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            width: 1px;
            height: 20px;
            top: 10px;
            background: #cccccc;
          }
        }
      }
    }
  }
}
</style>
